$(document).click(function (event) {

    if ($(event.target).closest('.datepickers-container').length) {
        return;
    }

    if ($(event.target).closest('.datepicker--cell').length) {
        return;
    }

    if (!$(event.target).closest('.options').length && $('.options__item').hasClass('is-active')) {
        $('.options__item').removeClass('is-active');
    }

    if (!$(event.target).closest('.search').length && $('.search').hasClass('is-active')) {
        hideSearchFields();
    }

    if (!$(event.target).closest('.filter').length && $('.filter').hasClass('is-active') && (!$(event.target).attr('class') || !$(event.target).attr('class').includes('datepicker--nav')) && (!$(event.target).closest('div').attr('class') || !$(event.target).closest('div').attr('class').includes('datepicker--nav'))) {
        hideFilter(); 
    }
});

$(document).ready(function () {
    initDependentInteraction();
    initThemeFunctions();
    expandAccordionOnError();
    handleNewBlock();
    initAccordionInteraction();
    initSortable();
    initRegistrationFormTypeSelect();
    initColorPickers();
    addNoHyphensListener();
    addSearchFieldSubmitKeyListener();
    showHideDeleteButtonTimeSlot();
    initDatepicker();

    $('.js-options-trigger').click(function () {
        if (!$(this).next('.options__item').hasClass('is-active')) {
            $('.options__item').removeClass('is-active');
            $(this).next('.options__item').addClass('is-active');
        } else {
            $('.options__item').removeClass('is-active');
        }
    });

    $('.js-search-trigger').click(function() {
        if (!$(this).closest('.search').hasClass('is-active')) {
            showSearchFields();
            initSearchBtnFunctionality();
        }
    });

    $('.js-filter-trigger').click(function() {
        if (!$(this).closest('.filter').hasClass('is-active')) {
            showFilter();
            initFilterBtnFunctionality();
        }
    });

    $('.js-file').each(function() {
        var $input = $(this),
            $label = $input.next('label'),
            labelVal = $label.html();
            
        $input.on('change',
            function(e) {
                var fileName = '';

                if (e.target.value) {
                    fileName = e.target.value.split('\\').pop();
                }

                if (fileName) {
                    $label.find('span').html(fileName);
                } else {
                    $label.html(labelVal);
                }
            });
    });

    $('.js-toggle-readonly').change(function () {
        var field = $(this).data('field-for'),
            el = $('input[data-field=' + field + ']');

        if (el.hasClass('readonly')) {
            el.removeAttr('readonly');
            el.removeClass('readonly');
        } else {
            el.attr('readonly', 'readonly');
            el.addClass('readonly');
        }
    });

    $('.js-participatingStatus').change(function () {
        var selectedVal = $(this).val();
        if (selectedVal !== '2') //!= from subcribe
        {
            //the worshops should be unchecked
            $('.workshopChx').each(function() {
                $(this).attr('checked', false);
            });
        }
    });

    $('.js-all-to-waitinglist').change(function () {
        var ids = $("#selectedIds").val();
        var eventId = $(this).data("eventid");
        allToWaitingList(ids, eventId);
    });

    $('.js-all-to-attend').change(function () {
        var ids = $("#selectedIds").val();
        var eventId = $(this).data("eventid");
        allToAttend(ids, eventId);
    });

    $('.js-open-confirm-popup').click(function (e) {
        e.preventDefault();
        var overlayTitle = $(this).data("title");
        var message = $(this).data("message");
        var $overlay = $('.overlay[data-overlay=confirm-box]');
        var url = $(this).data("url");
        var ajaxCallUrl = $(this).data("ajax");

        if (url) {
            $overlay.find('.js-redirect-url').val(url);
        }
        if (ajaxCallUrl) {
            $overlay.find('.js-ajax-call').val(ajaxCallUrl);
        }
        $overlay.find('.overlay__title').html(overlayTitle);
        $overlay.find('.overlay__message').html(message);
        $overlay.addClass('act animate');
    });

    $('.js-confirm').click(function() {
        var $overlay = $(this).closest('.overlay');
        var url = $overlay.find('.js-redirect-url').val();
        var ajaxCallUrl = $overlay.find('.js-ajax-call').val();
        if (ajaxCallUrl) {
            var ids = $("#selectedIds").val();
            $.ajax({
                url: PROJECT_URL + ajaxCallUrl,
                cache: false,
                type: "post",
                async: false,
                data: {
                    idsStr: ids
                }
            }).done(function(data) {
                location.reload();
            });
        }
        window.location = url; 
    });

    $('.js-invitation-email').click(function() {
        var ids = $("#selectedIds").val();
        $.ajax({
            url: PROJECT_URL + "/Communications/Invitation",
            cache: false,
            type: "post",
            async: false,
            data: {
                idsStr: ids
            }
        }).done(function(data) {
            location.reload();
        });
    });
    
    $('.js-open-import-popup').click(function (e) {
        e.preventDefault();
        var $overlay = $('.overlay[data-overlay=import-box]');
        $overlay.addClass('act animate');
    });

    $('.js-import').click(function () {
        var file = $('#importFile')[0].files[0];
        var eventId = $(this).data("eventid");
        var upload = new Upload(file);

        if (file) {
            if (upload.getSize() > 0 && upload.getType() === 'csv') {
                // execute upload
                upload.doUpload(eventId);
            } else {
                $('.overlay[data-overlay=import-box]').find('.alert').removeClass('u-d-none');
            }
        }
        else {
            $('.overlay[data-overlay=import-box]').find('.alert').removeClass('u-d-none');
        }
    });

    $('.js-create-bulk-email').click(function(event) {

        $(this).addClass('')

        var chooseTemplateButton = $(this).attr('data-choose-template-button') || "Choose template";
        var relationIds = $("#selectedIds").val();
        var urlParams = new URLSearchParams(window.location.search);
        var eventId = urlParams.get('parentId');

        const overlay = 'create-bulk-email';
        showOverlay(overlay);

        $.ajax({
            type: "POST",
            url: `/Users/EmailTemplateList?eventid=${eventId}`,
            data: "{}",
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            success: function (response) {
                var templates = response;
                setBulkEmailTemplate(eventId, templates, relationIds, undefined, chooseTemplateButton);
            },
            failure: function (errorMessage) {
                setBulkEmailTemplate(eventId, templates, relationIds, errorMessage, chooseTemplateButton);
            }
        });

        $('.overlay[data-overlay=' + overlay + ']').find('.overlay__message').html(`
            <div class="bulk-email">
                <div class="bulk-email__item">
                    <span class="ui-spinner">Loading</span>
                </div>
            </div>
        `);

    })

    function setBulkEmailTemplate(eventId, templates, relationIds, errorMessage, chooseTemplateButton) {

        const overlay = 'create-bulk-email';

        const html = `
            <div class="bulk-email">
                ${ templates && templates.length > 0 ? templates.map(template => {
                    return `
                        <div class="bulk-email__item">
                            <span>${template.Title}</span>
                            <span class="btn js-pick-email-template" data-template-id="${template.Id}">${chooseTemplateButton || 'Choose template'}</span>
                        </div>`;
                }).join('') : 
                    `
                    <div class="bulk-email__item">
                        <span class="alert alert--danger">${errorMessage || 'Er zijn geen templates'}</span>
                    </div>
                    `
                }
            </div>
        `

        $('.overlay[data-overlay=' + overlay + ']').find('.overlay__message').html(html);

        $('.js-pick-email-template').off().on('click', function() {
            const templateId = $(this).attr('data-template-id')
            const url = new URL(`${PROJECT_URL}Communications/OpenWithUserList`)
            url.searchParams.append('id', templateId);
            url.searchParams.append('parentId', eventId);
            url.searchParams.append('userList', relationIds)

            window.location = url;
        })
    }

    $('.js-event-language').change(function() {
        var lang = $(this).data("lang");
        var langIds = $('#LangIds').val();

        if ($(this).is(":checked")) {
            if (langIds != "")
                $('#LangIds').val(langIds + "," + lang);
            else
                $('#LangIds').val(lang);
        } else {
            langIds = langIds.replace(lang + ",", "").replace("," + lang, "").replace(lang, "");
            $('#LangIds').val(langIds);
        }
    });

    $('.js-add-timeslot').click(function() {
        var regexName = /TimeSlots\[([0-9]*)\]\./;
        var regexId = /TimeSlots_([0-9]*)__/;

        var timeslot = $(".timeslot:visible").last().clone().insertAfter(".full-timeslot:last").addClass('full-timeslot');

        timeslot.find("input").each(function() {
            var name = this.name;
            var matchName = name.match(regexName);
            if (matchName) {
                this.name = this.name.replace(matchName[1], timeSlotIndex);
            }

            var id = this.id;
            var matchId = id.match(regexId);
            if (matchId) {
                this.id = this.id.replace(matchId[1], timeSlotIndex);
            }
            $(this).removeClass('hasDatepicker');
            
        });
        timeslot.find(".js-delete-timeslot").each(function() {
            $(this).data("title", "");
            $(this).data("message", "");
            $(this).attr("data-timeslot-index", timeSlotIndex);
        });

        initDatepicker(); 
        initForm();
        initDeleteTimeSlot();
        showHideDeleteButtonTimeSlot();

        timeSlotIndex++;
    });

    function initDeleteTimeSlot() {      
            $('.js-delete-timeslot').off().on('click', removeTimeSlot);
    }

    initDeleteTimeSlot()

    $('.js-mp4Video').click(function(event) {
        var youtubeLinkId = $(this).data('youtube-field-id');
        $('#' + youtubeLinkId).val('');
        var deleteId = $(this).data('delete-file-id');
        $('#' + deleteId).attr('checked', false);
    });

    $('.js-youtubeRadio').click(function(event) {
        var deleteId = $(this).data('delete-file-id');
        $('#' + deleteId).attr('checked', true);
    });

    $('#UserType').change(function () {
        $(".userTypeText").addClass("hidden");
        $("#userType_" + $(this).find(':selected').text()).removeClass("hidden");
    });

    $('.numeric').on('keypress', function () {
        var k = (document.all ? e.keyCode : e.which);
        return ((k > 47 && k < 58) || k == 46 || k == 8 || k == 9 || k == 0);
    })

    $('.languageDd').change(function () {
        location.href = $(this).val();
    });

    $('#site').change(function () {
        location.href = $(this).val();
    });
});

function removeTimeSlot(parameters) {
    var overlayTitle = $(this).data("title");
    var message = $(this).data("message");
    if (overlayTitle && message) {
        var $overlay = $('.overlay[data-overlay=confirm-box-timeslot-delete]');
        var index = $(this).data("timeslot-index");
        $overlay.find('.overlay__title').html(overlayTitle);
        $overlay.find('.overlay__message').html(message);
        $overlay.addClass('act animate');
        $overlay.find(".js-delete-timeslot").each(function () {
            $(this).data("timeslot-index", index);
        });
        
    } else {
        if ($('.full-timeslot:visible').length > 1) {
            var timeSlotToDelete = $('button[data-timeslot-index=' + $(this).data("timeslot-index") + ']');
            timeSlotToDelete.parents(".full-timeslot").hide();
            timeSlotToDelete.parents("div.row.timeslot").find(".js-to-delete").val("true");
            if ($(this).data('overlay')) {
                $('.overlay[data-overlay="' + $(this).data('overlay') + '"]').removeClass('act');
            }
        }
    }

    showHideDeleteButtonTimeSlot();
}


function showHideDeleteButtonTimeSlot() {
    if ($('.full-timeslot:visible').length > 1) {
        $('.full-timeslot:visible').find('.js-delete-timeslot').show();
    } else {
        $('.full-timeslot:visible').find('.js-delete-timeslot').hide();
    }
}

var initDependentInteraction = function () {
    $('.js-dependent-option').each(function() {
        var dependentBlock = $(this).data('dependent-block');

        if ($(this).is(':radio')) {
            if ($(this).is(':checked')) {
                var value = $(this).val();
            }
            else {
                return;
            }
        } else if ($(this).is(':checkbox')) {
            var value = $(this).is(':checked');
        }

        showDependentBlock(dependentBlock, value);
    });

    $('.js-dependent-option').on('change', function () {
        var dependentBlock = $(this).data('dependent-block');
        var value;

        if ($(this).is(':radio')) {
            value = $(this).val();
        }
        else if ($(this).is(':checkbox')) {
            value = $(this).is(':checked');
        }

        showDependentBlock(dependentBlock, value);
    });

    $('.js-dependent-link').click(function () {
        var dependentBlock = $(this).data('dependent-block');
        var value = $(this).data('dependent-value')
        showDependentBlock(dependentBlock, value);
    })
}

var initAccordionInteraction = function () {
    $('.accordion.is-active').each(function () {
        var accordionBody = $(this).find('.accordion__body');
        accordionBody.slideDown(200);
    })

    $('.js-accordion-trigger').click(function () {
        var accordion = $(this).closest('.accordion');
        toggleAccordionBody(accordion);
    });
}

var showDependentBlock = function (dependentBlock, value) {
    $('[data-dependent=' + dependentBlock + ']').each(function (i) {
        if (String($(this).data('dependent-value')) == String(value)) {
            $(this).show();
        } else {
            $(this).hide();
        }
    });
}

var showSearchFields = function() {
    $('.search').addClass('is-active');
    $('.js-search-input').focus();
    $('.js-search-btn').show();
    $('.js-search-trigger').hide();
}

var hideSearchFields = function() {
    $('.search').removeClass('is-active');
    $('.js-search-btn').hide();
    $('.js-search-trigger').show();
}

var addSearchFieldSubmitKeyListener = function() {
    $('.js-search-input').keypress(function(event) {
        if (event.keyCode === 13) {
            event.preventDefault();
            doSearchMagic($('.js-search-btn'));
        }
    });
}

var showFilter = function () {
    $('.filter').addClass('is-active').removeClass('is-filtered');
    initDatepicker();
}

var hideFilter = function () {
    $('.filter').removeClass('is-active');
}

var initSearchBtnFunctionality = function () {
    $('.js-search-btn').on('click', function () {
        doSearchMagic($(this));
    });
}

var initFilterBtnFunctionality = function () {
    $('.js-filter-event-btn').on('click', function () {
        filterEvent($(this));
    });
}

var initDatepicker = function () {

    $('.datepicker-here').each(function(i, e) {

        var currentDate = $(this).data('datepicker');

        if (!currentDate) {
            $(this).datepicker({
                changeMonth: true,
                changeYear: true,
                dateFormat: 'dd-mm-yyyy',
                gotoCurrent: true,
                showAnim: 'slideDown',
                numberOfMonths: 1,
                showWeek: false,
                firstDay: 1,
                showOtherMonths: true,
                selectOtherMonths: true,
                timeFormat: 'hh:mm',
                showTimepicker: false
            });
        }

        if (currentDate && e.value) {

            var dpDateTime = strToDate(e.value)

            if (dpDateTime) {

                if (isNaN(dpDateTime.getTime())) {
                    return
                }

                var dp = $(this).datepicker().data('datepicker');

                dp.selectDate(dpDateTime);
            }
        }

    })
}

function strToDate(dtStr) {

    let dateParts = dtStr.split("-");
    var dateObject = new Date();

    try {
        let timeParts = dateParts[2].split(" ")[1].split(":");
        dateObject.setHours(timeParts[0]);
        dateObject.setMinutes(timeParts[1]);
        dateParts[2] = dateParts[2].split(" ")[0];
    } catch (error) {
    }

    // month is 0-based, that's why we need dataParts[1] - 1
    dateObject.setDate(dateParts[0]);
    dateObject.setMonth(dateParts[1] - 1);
    dateObject.setFullYear(dateParts[2]);

    return dateObject;

}

var initSortable = function () {
    // Return a helper with preserved width of cells
    var fixHelper = function (e, ui) {
        ui.children().each(function () {
            $(this).width($(this).width());
        });
        return ui;
    };

    $('.table--sortable').find('tbody').sortable({
        helper: fixHelper
    }).disableSelection();
}

var initColorPickers = function() {
    var $selectedPickerField;
    $('.colorselector').ColorPicker({
        onSubmit: function (hsb, hex, rgb, el) {
            $(el).val(hex);
            $(el).ColorPickerHide();
        },
        onBeforeShow: function () {
            $selectedPickerField = this;
            $(this).ColorPickerSetColor(this.value);
        },
        onHide: function (colpkr) {
            $(colpkr).fadeOut(500);
            return false;
        },
        onChange: function (hsb, hex, rgb) {
            $($selectedPickerField).val(hex).removeClass('error');
            $($selectedPickerField).parent().find('.color-preview').css('background', '#' + hex);
        },
    })
        .bind('keyup', function () {
            $(this).ColorPickerSetColor(this.value);
        });
};

var saveSort = function () {
    var list = $('.table--sortable').find('tbody').sortable('serialize', { key: "sortedList" });

    $('<input>').attr({
        type: 'hidden',
        id: 'sortedList',
        name: 'sortedList',
        value: list.replace(/\&sortedList=/g, ",").replace(/sortedList=/, "")
    }).appendTo('form');

    if ($('#parentId').length > 0) {
        $('<input>').attr({
            type: 'hidden',
            id: 'parentId',
            name: 'parentId',
            value: $('#parentId').val()
        }).appendTo('form');
    }
    return false;
}

var initRegistrationFormTypeSelect = function () {
    $('.js-select-form-type').each(function () {
        var $el = $(this);
        registrationFormTypeSelectInteraction($el);
    }); 

    $('.js-select-form-type').on('change', function () {
        var $el = $(this);
        registrationFormTypeSelectInteraction($el);
    });
}

var registrationFormTypeSelectInteraction = function ($el) {
    // 7 = optielijst, 8 = keuzelijst, 9 = checkboxlijst
    if ($el.val() == '7' || $el.val() == '8' || $el.val() == '9' || $el.val() == '2') {
        $('.js-form-type-field').show();
    } else {
        $('.js-form-type-field').hide();
    }
    // 7 = optielijst, 8 = keuzelijst, 9 = checkboxlijst
    if ($el.val() == '7' || $el.val() == '8' || $el.val() == '9') {
        $('.js-form-type-label').show();
    } else {
        $('.js-form-type-label').hide();
    }

    if ($el.val() == '18') {
        $('.js-max-tickets-field').show();
    } else {
        $('.js-max-tickets-field').hide();
    }
}

var toggleAccordionBody = function (accordion) {
    var accordionBody = accordion.find('.accordion__body');
    accordion.toggleClass('is-active');
    accordionBody.slideToggle(200);
}

var filterEvent = function (filterBtn) {
    var sort = $('#shortFilterSort').val();
    var pagesize = $('#shortFilterPagesize').val();
    var publishObj = $('#filter_published');
    var notPublishObj = $('#filter_not_published');
    var createDate = $('#filter_create_dt').val();
    var startDate = $('#filter_start_dt').val();
    var endDate = $('#filter_end_dt').val();
    var eventOwnerIds = "";

    $('.js-event-owner').each(function (index) {
        if ($(this).is(":checked")) {
            if (eventOwnerIds !== "")
                eventOwnerIds = eventOwnerIds + "|";
            eventOwnerIds = eventOwnerIds + $(this).val();
        }
    });

    var form = filterBtn.closest('form');
    var pageUrl = form.attr('action');
    
    var indexOfParams = pageUrl.indexOf("?");
    if (indexOfParams > 0) {
        pageUrl = pageUrl.substring(0, indexOfParams + 1);
    } else {
        pageUrl = pageUrl + "?";

    }
    
    var url = pageUrl + "sort=" + sort + "&page=1" + "&pagesize=" + pagesize + "&publish=" + publishObj.is(":checked") + "&notPublish=" + notPublishObj.is(":checked") + "&createDate=" + createDate + "&startDate=" + startDate + "&endDate=" + endDate + "&ownerIds=" + eventOwnerIds;

    window.location = url;
}

var doSearchMagic = function (searchBtn) {

    var urlParams = new URLSearchParams(window.location.search);
    var sort = urlParams.get('short') || '';
    var page = urlParams.get('page') || '';
    var pagesize = urlParams.get('pagesize') || '';
    var eventId = urlParams.get('eventId') || '';
    var parentId = urlParams.get('parentId') || '';
    var publish = urlParams.get('publish') || '';
    var notPublish = urlParams.get('notPublish') || '';
    var createDate = urlParams.get('createDate') || '';
    var startDate = urlParams.get('startDate') || '';
    var endDate = urlParams.get('endDate') || '';
    var ownerIds = urlParams.get('ownerIds') || '';
    var form = searchBtn.closest('form');
    var pageUrl = form.attr('action');

    var arraySearchFields = [];
    var arraySearchFieldsValues = [];

    $('.js-search-input').each(function (index) {
        arraySearchFields.push($(this).attr('id'));
        arraySearchFieldsValues.push($(this).val());
    });

    var indexOfParams = pageUrl.indexOf("?");
    if (indexOfParams > 0) {
        pageUrl = pageUrl.substring(0, indexOfParams + 1);
    } else {
        pageUrl = pageUrl + "?";
    }

    var url = pageUrl + "sort=" + sort + "&page=" + page + "&pagesize=" + pagesize + "&eventId=" + eventId + "&parentId=" + parentId + "&publish=" + publish + "&notPublish=" + notPublish + "&createDate=" + createDate + "&startDate=" + startDate + "&endDate=" + endDate + "&ownerIds=" + ownerIds;

    for (var i = 0; i < arraySearchFields.length; i++) {
        url = url + "&" + arraySearchFields[i] + "=" + arraySearchFieldsValues[i];
    }

    window.location = url;
}

var initThemeFunctions = function () {
    $(".js-load-theme").on('click', function () {
        var siteId = $('.js-site-id').val();
        var themeId = $('.js-select-theme').val();
        var fontType = $('.js-event-fonttype').val();

        if (themeId) {
            loadTheme(siteId, themeId, fontType);
        }
        else {
            alert('Geen thema geselecteerd');
        }
    });

    $('.js-close-overlay').on('click', function (e) {
        e.preventDefault();
        closeOverlay($(this).data('overlay'));
    });

    $('.js-close-overlay-refresh').on('click', function (e) {
        location.reload();
    });
    
    $('.btn-overlay').on('click', function (e) {
        e.preventDefault();
        showOverlay($(this).data('overlay'), $(this).data('source'));
    });

    $(".js-save-theme").click(function (e) {
        e.preventDefault();
        saveTheme($(this), $('#ThemeName'));
    });

    $('.js-close-overlay-block').on('click', function (e) {
        e.preventDefault();
        $('.overlay[data-overlay=' + $(this).data('overlay') + ']').find('.overlay__inner').html("");
        closeOverlay($(this).data('overlay'));
    });
}

var loadTheme = function (siteId, themeId, fontType) {
    $.ajax({
        url: PROJECT_URL + "Themes/GetThemeById",
        cache: false,
        type: "get",
        async: true,
        data: {
            themeId: themeId,
            siteId: siteId
        }
    }).done(function (data) {
        $(".themes").html(data);
        notifyUser('Theme has been loaded successfully.', 'info');
        setColorSelectors();
        initThemeFunctions();
    });
}

var saveTheme = function ($el, $elThemeName) {
    if ($elThemeName.val() == '') {
        checkField($elThemeName);
        return false;
    }

    $(".save-theme").hide();
    $(".save-theme-loading").show();
    $(".save-theme-loading").html("<img src='" + PROJECT_URL + "content/img/loading.gif' />");

    $.ajax({
        url: PROJECT_URL + "Themes/SaveTheme",
        cache: false,
        type: "post",
        async: true,
        data: $('.themecolors').closest('form').serialize()
    }).done(function (data) {
        $(".theme-name").html(data);
        $(".save-theme-loading").html('');
        $(".save-theme-loading").append("<a href=\"#\" class=\"btn btn--grey js-close-overlay\" data-overlay=\"save-theme\">Close</a>");
        $elThemeName.hide();
        initThemeFunctions();
    });
}

function notifyUser(message, messageType) {
    var notificationContainer = $('main.container > form');

    var messageTypeClass = 'alert--error';

    if (messageType) {
        messageType === 2 || messageType.toLowerCase() === 'warning' ? messageTypeClass = 'alert--warning': null;
        messageType === 4 || messageType.toLowerCase() === 'info' ? messageTypeClass = 'alert--info': null;
        messageType === 8 || messageType.toLowerCase() === 'success' ? messageTypeClass = 'alert--success': null;
    }

    var notification = `<div class="alert ${messageTypeClass} alert--clickable js-notification">
        ${message}
        <span class="alert__close"><small>Close</small></span>
    </div>`;

    $(notificationContainer).prepend(notification);

    $('.js-notification').off().on('click', function() {
        $(this).hide();
    })
}

var showOverlay = function (overlay, source) {
    if (overlay == 'save-theme') {
        $('.themecolors .required').each(function () {
            checkField($(this));
        });
        if ($('.themecolors').find('.error').size() > 0) {
            return false;
        }
    }
    var isPopup = $(this).data("overlay") === "popup";
    if (source) {
        $.ajax({
            url: source,
            cache: false,
            type: "get",
            async: true,
        }).done(function (data) {
            if (isPopup)
                $('.overlay[data-overlay=' + overlay + ']').find('.overlay__inner').html(data + '<span class="btn btn--grey js-close-overlay" data-overlay="' + overlay + '">Sluiten</span>');
            else
                $('.overlay[data-overlay=' + overlay + ']').find('.overlay__inner').html(data);
            initDependentInteraction();
            initThemeFunctions();
            initAccordionInteraction();
            initForm();
        });
    }

    $('.overlay[data-overlay=' + overlay + ']').addClass('act animate');
}

var closeOverlay = function (overlay) {
    $(".save-theme-loading").hide();
    $(".save-theme").show();
    $('.overlay[data-overlay="' + overlay + '"]').removeClass('act');
}

var addNoHyphensListener = function() {

    $('.js-no-hyphens').keypress(function (event) {
        return event.keyCode !== 45
    })
}

var ClearCache = function() {
    $.ajax({
        url: PROJECT_URL + "xml/ClearCacheFrontend",
        cache: false,
        type: "get",
        dataType: "text",
        async: false,
        beforeSend: function () {
            $(".clearCache").addClass("act");
            $(".clearCache").html(busyMsg);
            $(".clearCache").attr("href", "#");
        },
        success: function (data) {
            $(".clearCache").html(data);
        },
        error: function (data) {
            $(".clearCache").html(data);
        }
    });
}

var Upload = function (file) {
    this.file = file;
};

Upload.prototype.getType = function () {
    return this.file.name.substr((this.file.name.lastIndexOf('.') + 1));
};
Upload.prototype.getSize = function () {
    return this.file.size;
};
Upload.prototype.getName = function () {
    return this.file.name;
};
Upload.prototype.doUpload = function (eventId) {
    var that = this;
    if (window.FormData !== undefined) {
        var formData = new FormData();
        // add assoc key values, this will be posts values
        formData.append("file", this.file, this.getName());
        formData.append("upload_file", true);
        formData.append("eventId", eventId);
        
        $.ajax({
            type: "POST",
            url: PROJECT_URL + "Users/Import",
            success: function (data) {
                var jsonObj = jQuery.parseJSON(data);

                closeOverlay('import-box');
                var resultOverlay = $('.overlay[data-overlay=import-result]')
                resultOverlay.addClass('act animate');

                if (jsonObj.Success == true && jsonObj.SuccessMessages.length > 0) {
                    resultOverlay.find('.overlay__message').text(jsonObj.SuccessMessages[0]);
                }
                if (jsonObj.Success == false && jsonObj.ErrorMessages.length > 0) {
                    resultOverlay.find('.overlay__message').text(jsonObj.ErrorMessages[0]);
                }
            },
            error: function(error) {
                // handle error
            },
            async: false,
            data: formData,
            cache: false,
            contentType: false,
            processData: false,
            timeout: 60000
        });
    }
    else {
        alert("This browser doesn't support HTML5 file uploads!");
    }
};

function PublishWithParentId(id, obj, parentId, controller, action) {
    var url = PROJECT_URL + "Pages/Publish";
    if (controller && action) url = PROJECT_URL + controller + '/' + action;
    $.ajax({
        url: url,
        cache: false,
        type: "post",
        dataType: "json",
        async: false,
        data: {
            Id: id,
            parentId: parentId,
            Publish: obj.value
        },
        success: function (data) {
            if (data.status === "error") {
                if (!obj.checked) {
                    $(obj).attr('checked', 'checked');
                } else {
                    $(obj).removeAttr('checked');
                }
                alert(data.error);
            } else {
                obj.value = !data.publish;
            }
        },
        error: function () {
            if (!obj.checked) {
                $(obj).attr('checked', 'checked');
            } else {
                $(obj).removeAttr('checked');
            }
            alert(data.error);
        }
    });
}

function Publish(id, obj, controller, action) {
    var url = PROJECT_URL + "Pages/Publish";
    if (controller && action) url = PROJECT_URL + controller + '/' + action;
    $.ajax({
        url: url,
        cache: false,
        type: "post",
        dataType: "json",
        async: false,
        data: {
            Id: id,
            Publish: obj.value
        },
        success: function (data) {
            if (data.status === "error") {
                if (!obj.checked) {
                    $(obj).attr('checked', 'checked');
                } else {
                    $(obj).removeAttr('checked');
                }
                alert(data.error);
            } else {
                obj.value = !data.publish;
            }
        },
        error: function () {
            if (!obj.checked) {
                $(obj).attr('checked', 'checked');
            } else {
                $(obj).removeAttr('checked');
            }
            alert(data.error);
        }
    });
}

var allToWaitingList = function (ids, eventId) {
    $.ajax({
        url: PROJECT_URL + "users/AddUsersToWaitingList",
        cache: false,
        type: "post",
        async: false,
        data: {
            userIds: ids, 
            eventId: eventId
        }
    }).done(function (data) {
        location.reload();
    });
}
var allToAttend = function (ids, eventId) {
    $.ajax({
        url: PROJECT_URL + "users/ChangeStatusToParticipate",
        cache: false,
        type: "post",
        async: false,
        data: {
            userIds: ids,
            eventId: eventId
        }
    }).done(function (data) {
        location.reload();
    });
}

function expandAccordionOnError() {
    $('.accordion').has('.field-validation-error').addClass('is-active')
}

function queryStringExists(field) {
    var url = window.location.href;
    if(url.indexOf('?' + field + '=') != -1)
        return true;
    else if(url.indexOf('&' + field + '=') != -1)
        return true;
    return false
}

function handleNewBlock() {
    if (queryStringExists('isNewBlock')) {
        $('.accordion').removeClass('is-active')
        $('.accordion').last().addClass('is-active');
        var offset = $('.accordion').last();
        console.log($('.accordion'), offset)
        $('html, body').animate({
            scrollTop: offset.top,
            scrollLeft: offset.left
        }, 300);
    } else {
        return;
    }
}